"use client"

import {useEffect, useState} from "react";
import {segmentStatusRequest} from "@/utils/api/SegmentStatus";
import {WalkSegmentStatus} from "@/types/Walk";

export default function useSegmentStatus(path_id: number, segment_id: number, token?: string) {
  const [data, setData] = useState<WalkSegmentStatus | undefined>(undefined)

  useEffect(() => {
    const fetchData = async (token: string) => {
      const fetched = await segmentStatusRequest(token, String(path_id), String(segment_id))
      if (fetched) {
        setData(fetched)
      }
    }
    if (!data && path_id && segment_id && token) {
      fetchData(token)
    }
  }, [token, path_id, segment_id, data])

  return data
}
